export const labels = {
	'en': {
		pageTitle: 'Admin',
	},
};
